export class SocialShare {

    _socialShareForm = null;

    constructor() {

        this.initSocialModal();
        let self = this;

        jQuery('.social-share-btn').unbind().click(function () {
            if (typeof window.modal.social_share === "function") {
                window.modal.social_share();
            }
        })

        jQuery('.share-links').find('.smd').unbind().click(function (e) {
            self.doShare(jQuery(this).data('type'))
        })
    }

    initSocialModal() {
        let socialShareForm = document.createElement('form');
        socialShareForm.innerHTML = this.socialHtml();
        this._socialShareForm = socialShareForm;
        let self = this;

        jQuery(this._socialShareForm).find('.smd').unbind().click(function () {
            self.doShare(jQuery(this).data('type'))
        })

        jQuery(this._socialShareForm).find('.copy').unbind().click(function () {
            let input = document.getElementById('social-share-url');
            self.copyToClipboard(input);
        })

        if (typeof window.modal === 'object') {
            window.modal.social_share = function () {
                let modal = this;
                modal.open('Teilen', '', socialShareForm, {width: '500px'});
            }
        }
    }

    loader(show = true) {
        if (typeof window.loader === 'function') {
            window.loader(show)
        }
    }

    doShare(type) {
        let title = jQuery("meta[property='og:title']").attr("content");
        let page_url = window.location.href;
        let category = jQuery('.el-course-cat').text();
        let url = '';
        let body = 'Sehr geehrte/r ...\n\n';
        body += 'Ich möchte Ihnen/Dir gerne dieses interessante Weiterbildungsangebot der Staatsanzeiger Akademie empfehlen: \n\n';
        body += category + ': ' + title + '\n\n';
        body += 'Zur vollständigen Beschreibung:\n\n';
        body += page_url + '\n\n';
        body += 'Beste Grüße,\n\n';

        switch (type) {
            case 'xing':
                url = 'https://www.xing.com/pages/staatsanzeiger/';
                break;
            case 'linkedin':
                url = 'https://www.linkedin.com/company/staatsanzeiger/mycompany/';
                break
            case 'twitter':
                url = 'https://twitter.com/sta_redaktion?lang=de/';
                break
            case 'facebook':
                url = 'https://de-de.facebook.com/staatsanzeiger/';
                break
            case 'instagram':
                url = 'https://www.instagram.com/personaler_im_oed/';
                break
            case 'mail':
                url = 'mailto:?subject=' + encodeURI(title) + '&body=' + encodeURI(body);
                break
        }

        if (url) {
            if (type === 'mail') {
                window.location.href = url;
            } else {
                window.open(url, '_blank');
            }
        }
    }

    copyToClipboard(copyText) {
        if (copyText) {
            copyText.select();
            copyText.setSelectionRange(0, 99999); /*For mobile devices*/
            document.execCommand("copy");
        }
    }

    getMailBody() {

    }

    socialHtml() {
        return `
            <div class="modal-social-share">
                <div class="share-links">
                    <div class="icon-container1 d-flex">
                        <div data-type="twitter" class="smd"> <i class="img-thumbnail fa fa-twitter-square fa-2x" style="color:#4c6ef5;background-color: aliceblue"></i>
                            <p>Twitter</p>
                        </div>
                        <div data-type="facebook" class="smd"> <i class="img-thumbnail fa fa-facebook-official fa-2x" style="color: #3b5998;background-color: #eceff5;"></i>
                            <p>Facebook</p>
                        </div>
                        <div data-type="xing" class="smd"> <i class="img-thumbnail fa fa-xing-square fa-2x" style="color: #00575c;background-color: #ced000;"></i>
                            <p>Xing</p>
                        </div>
                        <div data-type="linkedin" class="smd"> <i class="img-thumbnail fa fa-linkedin-square fa-2x " style="color: #0070ac;background-color: #eceff5;"></i>
                            <p>LinkedIn</p>
                        </div>
                        <div data-type="mail" class="smd"> <i class="img-thumbnail fa fa-envelope fa-2x " style="color: #006fc0;background-color: #eceff5;"></i>
                            <p>E-Mail</p>
                        </div>
                    </div>
                </div>
                <div class="modal-social-footer"> 
                    <label for="social-share-url">Seitenlink kopieren <span class="message"></span></label>
                    <br>
                    <div class="input-row"> 
                        <input class="url col-10" id="social-share-url" value="${window.location}" type="url" placeholder="" aria-describedby="inputGroup-sizing-default"> 
                        <div class="copy"><i class="fa fa-clone"></i></div> 
                    </div>
                </div>
            </div>`
    }
}



